var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeposit = function SvgDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M6.22 7.667h1.447a3 3 0 0 1 3 3H5.999l.001.666h5.333v-.666a3.719 3.719 0 0 0-.59-2h1.924a3.333 3.333 0 0 1 3.01 1.9C14.101 12.648 11.548 14 8.667 14c-1.841 0-3.4-.393-4.667-1.083V6.714a4.645 4.645 0 0 1 2.22.953m-2.887 5a.667.667 0 0 1-.666.666H1.333a.667.667 0 0 1-.666-.666v-6A.667.667 0 0 1 1.333 6h1.334a.667.667 0 0 1 .666.667v6M12 3.333a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-4.667-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  })));
};
export default SvgDeposit;